import { render, staticRenderFns } from "./OPOSKreditoren.vue?vue&type=template&id=4ec6fed4&"
import script from "./OPOSKreditoren.vue?vue&type=script&lang=ts&"
export * from "./OPOSKreditoren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports